export async function getTerms(terms) {
    const get_terms = await fetch(cg_vars.terms_api_url + "?taxonomy=" + terms);
    let myTerms = await get_terms.json();
    return myTerms;
}
